import {Text} from '@gs-ux-uitoolkit-react/text';
import {FormControl} from '@gs-ux-uitoolkit-react/form';
import {Input, InputProps} from '@gs-ux-uitoolkit-react/input';
import {ReactNode, memo} from "react";

type Props = {
  label?: string;
  error?: string;
  name: string;
  placeholder?: string;
  type?: InputProps['type'];
  leadingContent?: InputProps['leadingContent'];
  disabled?: boolean;
  helperText?: string;
  autoFocus?: boolean;
  labelSuffix?: ReactNode;
  allowedRegex?: RegExp;
  isRequired?: boolean;
  setValue: (newVal: string)=> void;
  forceCaps?: boolean;
  touched?: boolean;
} & InputProps;

export const FormInput = memo(function({ name, label, helperText, labelSuffix, allowedRegex,className, isRequired, error, value, setValue, forceCaps, touched, ...props }: Props) {
  return (
    <FormControl className={`${className?className : ''} relative`} >
      {label ? (
          <Text typography="textBody02Medium" className="mb-1 flex" color="colorTextNeutralBold">
            <label htmlFor={name}>
            {label}
            </label>
            {labelSuffix && labelSuffix}
            {isRequired && (
              <span className="text-gray-90 ml-1">
              *
            </span>
            )}
          </Text>
      ) : null}
      <Input
        name={name}
        onChange={(e) => {
          const val = e.currentTarget.value
          if(val && allowedRegex){
            if(allowedRegex.test(val))
              setValue(forceCaps ? val.toUpperCase(): val);
          } else
            setValue(forceCaps ? val.toUpperCase(): val);
        }

      }
        value={ value || ''}
        status={error  ? 'error' : props.status}
        inputId={name}
        {...props}
      />
      {helperText ? (
        <p className="text-xs text-gray-60 mt-1 font-normal">{helperText}</p>
      ): null}
      {error ? (
        <Text typography="textCaption01Regular" color="red060" className={`my-1`}>
          {error}
        </Text>
      ): null}

    </FormControl>
  );
}, (prevProps, nextProps)=>{
  return prevProps.value === nextProps.value &&
    prevProps.error === nextProps.error &&
    prevProps.disabled === nextProps.disabled &&
    prevProps.setValue === nextProps.setValue &&
    prevProps.onBlur === nextProps.onBlur &&
    prevProps.status === nextProps.status &&
    prevProps.isRequired === nextProps.isRequired &&
    prevProps.label === nextProps.label
})
